module.exports = __webpack_public_path__ + "img/crescent_moon.e92fee88.svg";